import { useState, useRef } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Loader2, CreditCard, CheckCircle2 } from "lucide-react";

const eur = (v) => Number(v || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });

export default function CaparraPayButton({ leadId, caparra, paid, commessa, publicToken = null, testid = "pay-caparra-btn" }) {
  const [loading, setLoading] = useState(false);
  const busyRef = useRef(false);
  const pay = async () => {
    if (busyRef.current) return;
    busyRef.current = true;
    setLoading(true);
    try {
      const url = publicToken ? `/public/outlook/${publicToken}/caparra/checkout` : `/leads/${leadId}/caparra/checkout`;
      const { data } = await api.post(url, { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore nell'avvio del pagamento");
      setLoading(false);
      busyRef.current = false;
    }
  };
  if (paid) {
    return (
      <div className="flex items-center gap-2 text-sm font-semibold text-green-500 no-print" data-testid="caparra-paid">
        <CheckCircle2 className="h-4 w-4" /> Caparra pagata{commessa ? ` · Commessa ${commessa}` : ""}
      </div>
    );
  }
  return (
    <Button onClick={pay} disabled={loading || !caparra} className="font-semibold no-print" data-testid={testid}>
      {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <CreditCard className="h-4 w-4 mr-2" />}
      Paga caparra{caparra ? ` (${eur(caparra)})` : ""}
    </Button>
  );
}
